<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt2"> </p>
<p class="PN"><span href="#/xhtml/contents#c_pt2" title="Link target outside of Sample">Part Two</span></p>
<p class="PST"><span href="#/xhtml/contents#c_pt2" title="Link target outside of Sample"><span class="SANS-B">El Palacio de las Luci</span><span class="SANS">é</span><span class="SANS-B">rnagas</span></span></p>
<p class="PSTL"><span href="#/xhtml/contents#c_pt2" title="Link target outside of Sample">(The Palace of the Fireflies)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part2.vue?4a512a9b